import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useConfigAppPath } from '@web-config-app/core-react';

/**
 * Redirects from non-locale entity create routes to locale entity create routes
 */
export function EntityCreateRedirect() {
  const { tabId, moduleId, childModuleId, environmentKey } = useParams<{
    tabId: string;
    moduleId: string;
    childModuleId: string;
    environmentKey: string;
  }>();

  const generateConfigPaths = useConfigAppPath();

  const { entityCreatePath } = generateConfigPaths({
    tabId,
    moduleId,
    childModuleId,
    environmentKey,
  });

  return <Navigate to={entityCreatePath} replace />;
}
